<template>
  <div class="badge text-center" :class="cssClass">
    {{label}}
  </div>
</template>

<script>
export default {
  name: "Tag",

  props:{
    cssClass: {type: String, default: 'info'},
    label: {type: String, default: ''},
  }

}
</script>

<style lang="scss" scoped>

  @import "../../../src/assets/layout/variables";

  .badge{
    font-size: 0.75rem;
    border-radius: 3px;
    padding: 0 .5rem;
    line-height: 2em;
    display: inline-flex;
    cursor: default;
    font-weight: 400;
    user-select: none;
    margin-bottom: .25rem;
    margin-right: .25rem;

    &.pointer{
      cursor: pointer;

      & > label{
          cursor: pointer !important;
        }

   }

    .badge{
      margin: 0 -8px 0 5px;
      display: inline-block;
      float: right;
    }

    .tag-addon{
      margin-left: .25rem;
    }

  }

  .success {
    background-color: $textColorSuccess;
  }

  .secondary {
    background-color: $textColorSecondary;
  }

  .primary {
    background-color: $textColorPrimary;
  }

  .danger {
    background-color: $textColorDanger;
  }

  .warning {
    background-color: $textColorWarning;
  }

  .info {
    background-color: $textColorInfo;
  }

</style>